<template>
  <div class="sidebar-frame">
    <div class="sidebar-brand">
      <img class="sidebar-brand__logo" :src="logo" alt="浙链 TRC" />
      <div class="sidebar-brand__copy">
        <strong>时序数智平台</strong>
        <span>enterprise console</span>
      </div>
    </div>

    <nav class="sidebar-scroll" aria-label="主导航">
      <!-- 侧栏容器统一负责动画，避免菜单内部过渡延迟切换并重复计算宽度。 -->
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.meta.activeMenu || $route.path"
        :collapse="isCollapse"
        :collapse-transition="false"
        :unique-opened="true"
        background-color="transparent"
        text-color="#d9eee0"
        active-text-color="#f5fff6"
      >
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import logo from "@/assets/images/zhelian-logo.png";

export default {
  components: { SidebarItem },
  data() {
    return { logo };
  },
  computed: {
    ...mapGetters(["sidebar", "routers"]),
    routes() {
      // return this.$router.options.routes
      return this.routers;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue